import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            韩漫大全 · 专业平台
          </span>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6">{aboutContent.title}</h2>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed text-left">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mt-10 pt-8 border-t border-background-200">
            {aboutContent.stats.map((stat, i) => (
              <div key={i} className="text-center">
                <div className="text-3xl md:text-4xl font-heading text-primary-500">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}